
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface DestinationFieldProps {
  form: UseFormReturn<any>;
}

const DestinationField: React.FC<DestinationFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="destination"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Destination</FormLabel>
          <FormControl>
            <Input
              placeholder="Enter destination"
              {...field}
              required
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DestinationField;
